import { createSelector } from '@reduxjs/toolkit';
import { any, pathOr, prop, values } from 'ramda';

export const selectFeatureFlags = (state) => state.featureFlags;
export const selectFeatures = createSelector(
  selectFeatureFlags,
  (featureFlags) => featureFlags.features
);

export const hasAnyFeatureFetched = createSelector(selectFeatures, (features) =>
  Object.values(features).some((feature) => feature.fetched)
);

export const hasAllFeaturesFetched = createSelector(selectFeatures, (features) =>
  Object.values(features).every((feature) => feature.fetched)
);

export const isAnyFeatureLoading = createSelector(selectFeatures, (features) =>
  any(prop('loading'), values(features))
);

export const getError = createSelector(selectFeatureFlags, (featureFlags) => featureFlags.error);

export const getShouldEnableMfa = createSelector(
  selectFeatures,
  pathOr(false, ['enable-MFA-2025', 'enabled'])
);
export const getShouldDisableSkipMfa = createSelector(
  selectFeatures,
  pathOr(false, ['disable-skip-MFA-2025', 'enabled'])
);
export const selectHasFeatureFlagsLoaded = createSelector(selectFeatureFlags, prop('hasLoaded'));

export const selectHaveAllFeatureFlagsLoaded = createSelector(selectFeatures, (features) =>
  Object.values(features).every((feature) => feature.fetched)
);

export const selectIsAnyFeatureFlagLoading = createSelector(selectFeatures, (features) =>
  any(prop('loading'), values(features))
);

export const selectFeatureFlag = (featureFlipName) =>
  createSelector(selectFeatures, (features) =>
    pathOr(false, [featureFlipName, 'enabled'], features)
  );
